import React, { createContext, ReactNode, useContext } from 'react';

export interface FeaturesContextValue {
  features: Record<string, boolean>;
}

export const FeaturesContext = createContext<FeaturesContextValue | null>(null);

if (process.env.NODE_ENV === 'development') {
  FeaturesContext.displayName = 'FeaturesContext';
}

export const useStravaFeatures = () => {
  const context = useContext(FeaturesContext);

  if (!context) {
    throw new Error(
      'useStravaFeaturesContext must be used within a FeaturesProvider'
    );
  }

  return context;
};

export interface FeaturesProviderProps extends Partial<FeaturesContextValue> {
  children: ReactNode;
}

export const FeaturesProvider = ({
  children,
  ...featuresContextValue
}: FeaturesProviderProps) => {
  return (
    <FeaturesContext.Provider
      value={{
        features: {},
        ...featuresContextValue
      }}
    >
      {children}
    </FeaturesContext.Provider>
  );
};

if (process.env.NODE_ENV === 'development') {
  FeaturesProvider.displayName = 'FeaturesProvider';
}
